
import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class ReopenCaseModal extends Vue {
	@Prop({ default: false })
	readonly value!: boolean

	@Prop({ required: true })
	readonly caseRecordName!: string

	@Prop({ default: "" })
	readonly caseTitle!: string

	get modalShown (): boolean {
		return this.value
	}

	set modalShown (newValue: boolean) {
		this.$emit("input", newValue)
	}
}
